import { SelectPicker } from 'rsuite';
import styles from './OfferBlockSelect.module.scss';

interface IOfferBlockSelectProps {
  offerBlocks: { value: string | number; label: string }[];
  value: string | number | null | undefined;
  onChange: (value: string | number) => void;
}

export const OfferBlockSelect = ({ offerBlocks, value, onChange }: IOfferBlockSelectProps) => {
  return (
    <div className={styles.container}>
      <SelectPicker id="bloco-de-ofertas-select" value={value ?? undefined} onChange={onChange} data={offerBlocks} searchable={false} />
    </div>
  );
};
